var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.isShowSdk ? _c('div', [_c('na-render', {
    attrs: {
      "na-id": "viewScrollAd",
      "scroll-id": "feed-list-wrap",
      "header-id": "page-title-bar",
      "view-data": _vm.adData,
      "custom-style": {
        height: '278px'
      },
      "on-show": _vm.handleShowAd,
      "on-click": _vm.handleClickAd,
      "on-close": _vm.handleCloseAd
    }
  }), _c('div', {
    staticClass: "ad-bottom-line"
  })], 1) : _vm.adType === 'api' && _vm.adAspectRatio ? _c('ad-space', {
    attrs: {
      "ad-info": _vm.adInfo,
      "ad-aspect-ratio": _vm.adAspectRatio,
      "ad-core-utils": _vm.adCoreUtils
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };